module.exports = __webpack_public_path__ + "img/2016-2.eafc9816.jpg";